import * as React from 'react';
import { IConstructionProgressImage } from '../../../types/constructionProgress';

import { Slide } from '../components/Slide';
import { Thumbnail } from '../components/Thumbnail';

interface IPreparedSlides {
  slides: React.ReactNode[];
  thumbnails: React.ReactNode[];
}

export const prepareSlides = (images: IConstructionProgressImage[]): IPreparedSlides => {
  const preparedSlides = images.reduce<IPreparedSlides>(
    (acc, image, idx) => {
      acc.slides.push(<Slide key={idx} src={image.fullUrl} />);
      acc.thumbnails.push(<Thumbnail key={idx} src={image.minUrl} />);

      return acc;
    },
    { slides: [], thumbnails: [] },
  );

  return preparedSlides;
};
